import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from '../../store/hooks'
import { sendPasswordReset } from '../../store/authSlice'

export default function ResetPasswordScreen() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    if (!email) { setError('Please enter your email.'); return }

    const result = await dispatch(sendPasswordReset(email))
    if (sendPasswordReset.fulfilled.match(result)) {
      setSent(true)
    } else {
      setError(result.payload as string)
    }
  }

  if (sent) {
    return (
      <div className="onboard-wrap" data-testid="reset-password-sent">
        <div className="onboard-box">
          <h2>Check your email</h2>
          <p>We sent a password reset link to <strong>{email}</strong>.</p>
          <button
            className="btn btn-primary gate-btn"
            onClick={() => navigate('/login')}
            data-testid="back-to-login-btn"
          >
            Back to login
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="onboard-wrap" data-testid="reset-password-screen">
      <div className="onboard-box">
        <h2>Reset Password</h2>
        <form onSubmit={handleSubmit} data-testid="reset-password-form">
          <input
            type="email"
            className="gate-input"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="reset-email-input"
          />
          {error && <div className="gate-err" data-testid="reset-error">{error}</div>}
          <button
            type="submit"
            className="btn btn-primary gate-btn"
            data-testid="reset-submit-btn"
          >
            Send reset link
          </button>
        </form>
        <div className="gate-links">
          <button
            className="link-btn"
            onClick={() => navigate('/login')}
            data-testid="reset-back-to-login"
          >
            Back to login
          </button>
        </div>
      </div>
    </div>
  )
}
